<template>
    <section v-if="hasPermissions(['Options-Vacant-Beds-Adjustment Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is the percent of time that is converted into "Available Time" for the Census Module. To modify an adjustment, click the Detail icon, make the change and click Save.
            </p>
        </div>

        <div class="row bar__container">
            <div class="col-md-6 py-0 mb-3 mt-2">
                <div class="input-field my-0" v-if="vacant_beds.length">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
        </div>

        <div class="tab-content" v-show="vacant_beds.length">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="vacant_beds"
                                :search="search"
                                :checkable="true"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                                :link="'/vacant_beds/'"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <UpdateModal 
            :title="'Vacant Bed Adjustment Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>
<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import UpdateModal          from    './UpdateModal'
import DinamicTable         from    '@/components/DinamicTable'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'VacantBedAdjustment',

    components: {
        Breadcrumb,
        WaitingModal,
        UpdateModal,
        DinamicTable,
        UnauthorizedComponent
    },
    data() {
        return {
            notyf,
            axios,
            title_page:         'Vacant Bed Adjustment',
            content_header:     this.$store.state.headers,
            rest_api:           `vacant_beds`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            vacant_beds:        [],
            array_options:      {},
        }
    },
    methods: {
         unshift_object(new_object){
            this.vacant_beds.unshift(new_object)
        },

        splice_object(splicing_object){
            this.vacant_beds.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal(){
            window.$('#static').modal('show')
        },

        modal_deletion(index){
            this.global_index  = index
            this.single_object = this.vacant_beds[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index){
            this.global_index  = index
            this.single_object = this.vacant_beds[index]
            
            window.$('#static-update').modal('show')
        },

        fill_data(data){
            this.vacant_beds = data.vacant_bed_ajustments
        },

        trashing(index){
            this.vacant_beds.splice(index, 1)
        },
    },

    async mounted() {
        if(this.hasPermissions(['Options-Vacant-Beds-Adjustment Read']))
        {
            await this.api_request()
        }
    }
}
</script>